import { Injectable } from '@angular/core';

import { bensRoute } from "../../shared/data.service";
import { bemTiposRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import {categoriasRoute} from "../../categorias/shared/data.service";

@Injectable()
export class BemTiposNavigationService {
  fatherRouter: string = bensRoute;
  categoriaRouter: string = categoriasRoute;
  moduleRouter: string = bemTiposRoute;

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = this.fatherRouter + '/' + this.categoriaRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/shared/bem-tipos-navigation.service.ts
 **/